// extracted by mini-css-extract-plugin
export default {"root":"TabletOrDesktopProductRecommendations_root__SoOaQ"};